<div class="notification" [ngClass]="type">
  <div
    class="notification__stripe"
    [style.background-color]="color | preserveContrastColor"
  ></div>
  <div class="notification__content--outer">
    <div class="notification__content--inner">
      <div class="notification__icon" *ngIf="type !== 'actionable'">
        <ng-container
          [ngTemplateOutlet]="iconTemplateRef || defaultIcon"
        ></ng-container>
      </div>
      <div class="notification__text">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="notification__action" *ngIf="actionTemplateRef">
      <ng-container *ngTemplateOutlet="actionTemplateRef"></ng-container>
    </div>
  </div>
  <plugins-button
    class="notification__close"
    [text]="true"
    [ariaLabel]="dismissLabel ?? ('notice.dismiss' | translate)"
    (clicked)="dismiss.emit()"
    *ngIf="type === 'toast' || type === 'toast-float'"
  >
    <icon-cancel [size]="16"></icon-cancel>
  </plugins-button>
</div>

<ng-template #defaultIcon>
  <icon-exclamation shape="circle" [size]="28"></icon-exclamation>
</ng-template>
